import type { PermissionOption as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type PermissionOption = {
  label: string;
  value: string;
};

export const fromGql = (item: GQLItem): PermissionOption =>
  take(item, 'label', 'value') as PermissionOption;
